<template>
  <table class="table is-fullwidth is-hoverable" role="presentation">
    <tbody v-if="loading">
      <td class="td-alert" colspan="100">
        <es-loader style="margin: 4.5rem"/>
      </td>
    </tbody>
    <tbody v-else-if="loadingError">
      <td class="td-alert" colspan="100">
        <es-exception
        exceptionMessage="There was an issue. Please try again or contact your administrator."
        margin="4.rem"
        />
      </td>
    </tbody>
    <tbody v-else-if="!nearMatches.length">
      <td class="td-alert" colspan="100">
        <es-exception
          exceptionMessage="No results found."
          margin="3rem"
        />
      </td>
    </tbody>
    <template v-else>
      <pid-pending-near-match-row
        v-for="nearMatch in nearMatches"
        :key="nearMatch.pidSubmissionId"
        :nearMatch="nearMatch"
      />
    </template>
  </table>
</template>

<script>

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEllipsisV,
} from '@fortawesome/pro-light-svg-icons';
import {
  faExclamationTriangle,
} from '@fortawesome/pro-solid-svg-icons';
import EsException from '@/components/EsException.vue';
import EsLoader from '@/components/EsLoader.vue';
import PidPendingNearMatchRow from '@/components/PidPendingNearMatchRow.vue';

library.add(
  faEllipsisV,
  faExclamationTriangle,
);

export default {
  components: {
    EsException,
    EsLoader,
    PidPendingNearMatchRow,
  },
  props: {
    nearMatches: {
      type: Array,
    },
    loading: {
      type: Boolean,
    },
    loadingError: {
      type: Boolean,
    },
  },
};
</script>

<style lang="sass" scoped>
  .td-alert
    padding: 2rem
    text-align: center
</style>
